// extracted by mini-css-extract-plugin
module.exports = {"field":"_0fce717cdb--field--oaKrW","label":"_0fce717cdb--label--FOczD","stack":"_0fce717cdb--stack--u4HBy"};